import React from 'react';
import SearchSvg from '../assets/icons/svgicons/Search.svg';

const Search = () => {
  return (
    <div>
      <div className="relative w-[286px] h-[37px] rounded-lg">
        <input
          className="w-full border-none pl-[60px]  h-full placeholder:pl-[px] px-4 py-3 placeholder-gray-500 text-gray-700 bg-white rounded-lg focus:outline-none focus:bg-white"
          type="text"
          placeholder="Search"
        />
        <div className="absolute top-0 left-0 mt-[8px] ml-[24px]">
          <img src={SearchSvg} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Search;
